import { ICommand } from "./ICommand";

export abstract class AbstractEntityCommand<TSource, TEntity, TCommand extends ICommand<TEntity> = ICommand<TEntity>> implements ICommand<TSource> {
  constructor(protected readonly _command: TCommand) {}

  protected abstract toEntity(source: TSource): TEntity;

  do(source: TSource): void {
    this._command.do(this.toEntity(source));
  }
}
